import React from 'react';

import { DateTime } from 'luxon';


// just pure text with parsing


// <DateSelector4 value={jsDate} onChange={setJsDate} inputClassName='' />
class DateSelector4 extends React.Component { 
  constructor(props) {
    super(props);
    this.state = {
      textValue: '',
    };
    if (this.props.value) {
      this.state.textValue = DateTime.fromJSDate(this.props.value).toFormat('M/d/yyyy');
    }
    this.onChange = this.onChange.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
  }

  onChange(newDate) {
    console.log('date changed value', { newDate });
    this.props.onChange(newDate);
  }

  onTextChange(ev) {
    let textValue = ev.target.value;
    let dateValue = DateTime.fromFormat(textValue, 'M/d/yyyy');
    console.log('text changed, date parsed?', { textValue, dateValue });
    if (dateValue.isValid) {
      console.log('date valid', {dateValueISo: dateValue.toISO() });
      this.setState({ textValue });
      this.props.onChange(dateValue.toJSDate());
    }
    else {
      this.setState({ textValue });
      this.props.onChange(null);
    }
    
  }
  render() {
    // let dejt = DateTime.fromJSDate(this.props.value);

    return (
      <div>
        <input
          type='text'
          value={this.state.textValue}
          onChange={this.onTextChange}
          placeholder='MM/DD/YYYY'
          className={this.props.inputClassName}
        />
        {
          this.props.value &&
          DateTime.fromJSDate(this.props.value).toFormat('MMM d yyyy')
        }
        {
          this.props.value === null &&
          'Invalid Date'
        }
      </div> 

    );
  }
}

export default DateSelector4;
